<script setup lang="ts">
import type { PreviewIncidentReportResponse } from '@roadfootage/api-client'

defineProps<{
  incident: PreviewIncidentReportResponse
}>()
</script>

<template>
  <q-card class="full-height column">
    <q-card-section>
      <div class="text-subtitle1 text-weight-medium">About this incident</div>
    </q-card-section>

    <q-banner
      v-if="incident.hasContentWarning"
      class="bg-negative text-white q-mx-md q-mb-md"
      rounded
      dense
    >
      <template #avatar>
        <q-icon name="mdi-alert" />
      </template>
      The description below may contain content that some viewers find distressing.
    </q-banner>

    <q-separator inset />

    <q-card-section>
      <p
        v-if="incident.incidentDescription"
        class="text-body2 text-grey-9 q-mb-none"
        style="white-space: pre-wrap"
      >
        {{ incident.incidentDescription }}
      </p>
      <p v-else class="text-body2 text-grey-5 text-italic q-mb-none">No description provided.</p>
    </q-card-section>
  </q-card>
</template>
